export function monitorValue(
    monitor,
    key,
    fallback = null
) {

    return monitor?.[key]?.value ?? fallback;

}